import { Link } from "react-router-dom";

import { useSyncStatusQuery, useTouchMutation } from "@/api/sync";
import { Button } from "@/components/ui";
import { t } from "@/i18n";
import { fmtDateTime } from "@/lib/utils";

/** Ilk senkron adimi — POST /sync/touch + /sync/status kaynak ilerlemesi
 * (gorev talimati madde 3). */
export function SyncStep() {
  const statusQuery = useSyncStatusQuery();
  const touchMutation = useTouchMutation();

  return (
    <div className="space-y-3">
      <Button type="button" variant="primary" disabled={touchMutation.isPending} onClick={() => touchMutation.mutate()}>
        {touchMutation.isPending ? t("kurulum.sync.starting") : t("kurulum.sync.start")}
      </Button>

      {touchMutation.data && (
        <div className="space-y-1 text-sm">
          {touchMutation.data.enqueued.length > 0 && (
            <p className="text-green">{t("kurulum.sync.enqueued", { n: touchMutation.data.enqueued.length })}</p>
          )}
          {touchMutation.data.cooldown.length > 0 && <p className="text-muted">{t("kurulum.sync.cooldown")}</p>}
        </div>
      )}

      <div className="summary-bar">
        <span className="text-[13px] font-bold uppercase tracking-[0.06em] text-muted">{t("kurulum.sync.progress")}</span>
        {statusQuery.isLoading && <span className="font-sans text-sm font-normal text-muted">{t("common.loading")}</span>}
        {statusQuery.isError && (
          <span role="alert" className="font-sans text-sm font-normal text-red">
            {t("common.error")}
          </span>
        )}
        {statusQuery.data && statusQuery.data.sources.length === 0 && (
          <span className="font-sans text-sm font-normal text-muted">{t("kurulum.sync.no_sources")}</span>
        )}
        {statusQuery.data && statusQuery.data.sources.length > 0 && (
          <span className="num text-xl font-bold text-ink">{statusQuery.data.sources.length}</span>
        )}
      </div>

      {statusQuery.data && statusQuery.data.sources.length > 0 && (
        <div className="overflow-x-auto">
          <table className="tbl min-w-[420px]">
            <thead>
              <tr>
                <th>{t("kurulum.sync.progress")}</th>
                <th>{t("admin.tenants.last_sync")}</th>
                <th>{t("admin.tenants.last_error")}</th>
              </tr>
            </thead>
            <tbody>
              {statusQuery.data.sources.map((source) => (
                <tr key={source.source}>
                  <td className="font-sans text-ink">{t(`source.${source.source}`) || source.source}</td>
                  <td className="font-sans text-muted">{fmtDateTime(source.last_success_at)}</td>
                  <td className="font-sans text-muted">{source.last_error ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Link to="/ozet" className="btn-link">
        {t("kurulum.sync.go_to_ozet")}
      </Link>
    </div>
  );
}
